/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { FormActionsComponent, FormComponent, FormInputComponent, ModalComponent, patternValidator, requiredValidator } from "typedb-cloud-framework";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { PartialWithId } from "../../../concept/base";
import { idPattern, idPatternErrorText, namePattern, namePatternErrorText } from "typedb-web-common/lib";
import { spaceDetailsPath } from "../../../routing/resource-paths";
import { ApplicationState } from "../../../service/application-state.service";
import { Router } from "@angular/router";
import { DialogResult } from "../../../service/dialog.service";
import { SpaceApi } from "../../../service/space/space-api.service";
import { SnackbarService } from "../../../service/snackbar.service";
import { Space } from "../../../concept/space";

export type SpaceUpdateDialogData = { space: Space };

@Component({
    selector: "tp-space-update-dialog",
    templateUrl: "./space-update-dialog.component.html",
    imports: [
        ModalComponent, AsyncPipe, FormInputComponent, FormActionsComponent, FormsModule, ReactiveFormsModule,
        FormComponent, MatFormFieldModule, MatInputModule
    ]
})
export class SpaceUpdateDialogComponent {
    readonly team = this.app.requireCurrentTeam();
    readonly isSubmitting$ = new Subject<boolean>();
    readonly form = this.formBuilder.nonNullable.group({
        id: [this.data.space.id, [patternValidator(idPattern, idPatternErrorText), requiredValidator]],
        name: [this.data.space.name, [patternValidator(namePattern, namePatternErrorText), requiredValidator]],
    });

    constructor(
        private dialogRef: MatDialogRef<SpaceUpdateDialogComponent, DialogResult>, private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: SpaceUpdateDialogData, private snackbar: SnackbarService,
        private spaceApi: SpaceApi, private app: ApplicationState, private router: Router,
    ) {
    }

    submit() {
        const form = this.form.value;
        const space: PartialWithId<Space> = { id: form.id!, name: form.name };
        this.spaceApi.updateSpace({
            uuid: this.data.space.uuid,
            id: space.id !== this.data.space.id ? space.id : undefined,
            name: space.name !== this.data.space.name ? space.name : undefined
        }).subscribe({
            next: () => {
                this.close("ok");
                if (space.id !== this.data.space.id) {
                    this.router.navigate([spaceDetailsPath(space, this.team)], { replaceUrl: true });
                }
                this.snackbar.success(`Space updated successfully`);
            },
            error: () => {
                this.isSubmitting$.next(false);
            },
        });
    }

    close(result?: DialogResult) {
        this.dialogRef.close(result);
    }
}
